import styled from 'styled-components';
import breakpoints from '../breakpoints';

const Button = styled.button`
    border: 1px solid #006AFF;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    height: 54px;
    letter-spacing: 0;
    line-height: 21px;
    text-align: center;
`;

const Hero = styled(Button)`
    background-color: #006AFF;
    color: #FFFFFF;
    width: 240px;
`;

const Primary = styled(Button)`
    background-color: #006AFF;
    color: #FFFFFF;
    width: 184px;
`;

const Secondary = styled(Button)`
    background-color: #FFFFFF;
    color: #006AFF;
    width: 184px;
`;

const Cta = styled(Button)`
    background-color: #006AFF;
    color: #FFFFFF;
    height: 42px;
    width: 100%;

    @media ${breakpoints.medium} {
        width: 155px;
    }
`;

export const Image = styled.img`
    height: 14px;
    margin-right: 16px;
    width: 14px;
`;

export const Video = styled(Button)`
    background-color: rgba(0,0,0,0.3);
    border: 1px solid white;
    color: white;
    /* // Hidden element that Optimizely will use for A/B testing. */
    display: none;
    /* display: block; */
    margin: 12px auto 0 auto;
    width: 240px;

    @media ${breakpoints.medium} {
        /* display: inline-block; */
        margin: 0 0 0 12px;
    }
`;

export default {
    Hero,
    Primary,
    Secondary,
    Cta,
    Image,
    Video,
};
